import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { momumpayPayout } from "../Redux/Action";
import { getUserIP } from "../Utils/newHelper";

export const Withdrawal = () => {
  const [message, setMessage] = useState(
    "Your withdrawal request is currently in progress."
  );

  const dispatch = useDispatch();

  useEffect(() => {
    let ip;
    const queryParams = new URLSearchParams(window.location.search);
    const payload = queryParams.get("payload");

    const fetchIP = async () => {
      ip = await getUserIP();
      dispatch(
        momumpayPayout({
          ip,
          encryptedPayload: payload,
          callback: (data) => {
          
          },
        })
      );
    };

    fetchIP();
  }, []);
  
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text fontSize="md" textAlign="center">
        {message}
      </Text>
    </Box>
  );
};
